<template>
  <v-app-bar color="primary" density="comfortable" elevate-on-scroll>
    <v-btn icon @click="$emit('toggle-drawer')">
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="ml-2">Flota</v-toolbar-title>

    <v-spacer />

    <!-- Navegación principal -->
    <div class="d-none d-sm-flex align-center">
      <v-btn variant="text" class="mx-1" @click="go('/')">
        <v-icon start>mdi-view-dashboard</v-icon> Dashboard
      </v-btn>

      <v-btn variant="text" class="mx-1" @click="go('/vehicles')">
        <v-icon start>mdi-car</v-icon> Vehículos
      </v-btn>

      <!-- NUEVO: Depósitos (visible a admin, capturista y reportes) -->
      <v-btn
        v-if="canCapture || canReports"
        variant="text"
        class="mx-1"
        @click="go('/deposits')"
      >
        <v-icon start>mdi-bank-transfer</v-icon> Depósitos
      </v-btn>

      <v-btn
        v-if="canCapture"
        variant="text"
        class="mx-1"
        @click="go('/import')"
      >
        <v-icon start>mdi-file-upload</v-icon> Importar
      </v-btn>

      <v-btn
        v-if="canReports"
        variant="text"
        class="mx-1"
        @click="go('/reports')"
      >
        <v-icon start>mdi-chart-bar</v-icon> Reportes
      </v-btn>

      <v-btn
        v-if="canCapture || isAdmin"
        variant="text"
        class="mx-1"
        @click="go('/maintenance/templates')"
      >
        <v-icon start>mdi-wrench-clock</v-icon> Plantillas
      </v-btn>
    </div>

    <!-- Usuario -->
    <v-divider vertical class="mx-3 d-none d-sm-flex" />
    <div class="d-none d-sm-flex align-center">
      <v-icon class="mr-1">mdi-account-circle</v-icon>
      <span class="mr-3">{{ userName }} <small>({{ auth.user?.rol || '-' }})</small></span>
      <v-btn size="small" variant="tonal" color="white" @click="logout">
        <v-icon start>mdi-logout</v-icon> Salir
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useLookupStore } from '@/stores/lookups'

defineEmits(['toggle-drawer'])

const router = useRouter()
const auth = useAuthStore()
const lookup = useLookupStore()

// Derivados del usuario
const userName   = computed(() => auth.user?.nombre || 'Usuario')
const isAdmin    = computed(() => auth.user?.rol === 'admin')
const canCapture = computed(() => ['admin', 'capturista'].includes(auth.user?.rol))
const canReports = computed(() => ['admin', 'reportes'].includes(auth.user?.rol))

// Evita cargar catálogos si no hay sesión (cuando estás en /login)
onMounted(async () => {
  if (auth.token && lookup.departments.length === 0) {
    try { await lookup.load() } catch {}
  }
})

function go (path) {
  router.push(path)
}
function logout () {
  auth.logout()
  router.push({ name: 'login' })
}
</script>
